export const INTERNAL_OPERATION_TYPES = [2]
export const TRANSACTION_TYPES = {
  1: 'TransactionTypes | 1',
  2: 'TransactionTypes | 2',
  9: 'TransactionTypes | 9',
  10: 'TransactionTypes | 10',
  30: 'TransactionTypes | 30',
  31: 'TransactionTypes | 31',
  42: 'TransactionTypes | 42',
  51: 'TransactionTypes | 51',
  52: 'TransactionTypes | 52',
  56: 'TransactionTypes | 56',
  57: 'TransactionTypes | 57',
  66: 'TransactionTypes | 66',
  67: 'TransactionTypes | 67',
  69: 'TransactionTypes | 69',
  74: 'TransactionTypes | 74',
  75: 'TransactionTypes | 75',
  85: 'TransactionTypes | 85',
  86: 'TransactionTypes | 86',
  90: 'TransactionTypes | 90',
  91: 'TransactionTypes | 91',
  92: 'TransactionTypes | 92',
  93: 'TransactionTypes | 93',
  94: 'TransactionTypes | 94',
  99: 'TransactionTypes | 99',
  134: 'TransactionTypes | 134',
}

export const OPERATION_TYPES = {
  'OperationTypes | All': [
    1, 2, 9, 10, 30, 31, 42, 51, 52, 56, 57, 66, 67, 69, 74, 75, 85, 86, 90, 91,
    92, 93, 94, 99, 134,
  ],
  'OperationTypes | Wallet top up': [1, 9, 91, 93],
  'OperationTypes | Coinhold top up': [2],
  'OperationTypes | Referral payments to mining account': [10],
  'OperationTypes | Withdraw from wallet': [30, 90],
  'OperationTypes | Withdraw from wallet (free)': [31, 90],
  'OperationTypes | Withdraw to card': [42, 86, 94],
  'OperationTypes | Mining income to wallet': [51, 92],
  'OperationTypes | Referral payments to wallet': [52],
  'OperationTypes | Additional accrual': [56],
  'OperationTypes | Exchange coin': [57],
  'OperationTypes | Spending (P2P)': [66],
  'OperationTypes | Top up (P2P)': [67],
  'OperationTypes | Commission (P2P)': [69],
  'OperationTypes | Offer creation (P2P)': [74],
  'OperationTypes | Delisting from publication (P2P)': [75],
  'OperationTypes | Shared Mining income': [85],
  'OperationTypes | Commission (Cryptoprocessing)': [99],
}
